export default {
  cameras: [],
  motionCycle: false
};